import pickBy from 'lodash/pickBy';

// eslint-disable-next-line @typescript-eslint/ban-types
export const filterOutUndefinedProperties = <T extends {}>(object: T) =>
  pickBy(object, (value) => value !== undefined);
